import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil } from "@eres/core";
import { Lookup } from "@eres/ejari-api/Entity";
import { FormFieldProps, NullableFormValue, ValueConverter } from "@eres/forms";
import { MultiItemProps } from "@eres/forms-web/PickerInput";
import { formatAppDate } from "./Utils";

class LookupUtil<T> {
	cache: {
		[ key: string ]: T[]
	} = {};

	initCache() {

	}

	loadFromApi: ( key: string ) => Promise<T[]> = () => Promise.reject( "loadFromApi not configured" );

	getFromCache( key: string ): T[] | undefined {
		return this.cache[ key ];
	}

	putToCache( key: string, values: T[] ) {
		this.cache[ key ] = values;
	}

	getLookup( key: string ): Promise<T[]> {
		const cache = this.getFromCache( key );
		if ( cache ) return Promise.resolve( cache );
		return this.loadFromApi( key );
	}
}


const lkp = new LookupUtil();
export default lkp;

export const IdExtractor = ( e: any ) => e ? e.Id + "" : undefined;
export const IdentityExtractor = ( e: any ) => e ? e.Identity + "" : undefined;
export const LookupStateFormatter = ( e?: Lookup ) => e ? e.Id : undefined;
export const DateStateFormatter = ( e?: Date ) => e ? e.asServerString() : undefined;
export const IdExtractorFallback = ( e: any ) => {
	if ( e == null ) return undefined;
	if ( typeof e == "object" ) {
		return e.Id + "";
	} else return e.toString() + "";
};
export const IdentityExtractorFallback = ( e: any ) => {
	if ( e == null ) return undefined;
	if ( typeof e == "object" ) {
		return e.Identity + "";
	} else return e.toString() + "";
};
export const LocaleValueFormatter = ( e: LocaleValue ) => LocaleUtil.getLocalValue( e );
export const IdToTempLookup = ( idValue: string | number | undefined ) => {
	if ( idValue ) {
		return {
			Id: Number( idValue ),
			en: idValue + "",
			ar: idValue + "",
		} as Lookup;
	}
	return undefined;
};

class LookupConverter implements ValueConverter<Lookup, any> {
	fromData( data: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		let dt = typeof data;
		if ( dt === "number" || dt === "string" ) {
			if ( props ) {
				const p = props as MultiItemProps<Lookup, any>;
				if ( p.items && p.items.length > 0 )
					return p.items.find( x => data == ( p.toIdentifier ? p.toIdentifier( x ) : x.Id ) );
			}
		}
		return data;
	}

	toData( text: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		if ( text && typeof text === "object" ) return text.Id;
		return text;
	}
}

class LookupIdentityConverter implements ValueConverter<Lookup, any> {
	fromData( data: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		let dt = typeof data;
		if ( dt === "number" || dt === "string" ) {
			if ( props ) {
				const p = props as MultiItemProps<Lookup, any>;
				if ( p.items && p.items.length > 0 )
					return p.items.find( x => data == ( p.toIdentifier ? p.toIdentifier( x ) : x.Identity ) );
			}
		}
		return data;
	}

	toData( text: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		if ( text && typeof text === "object" ) return text.Identity;
		return text;
	}
}

export const lookupConverter = new LookupConverter();
export const lookupIdentityConverter = new LookupIdentityConverter();


class LookupDisplayConverter implements ValueConverter<Lookup, any> {
	fromData( data: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		let dt = typeof data;
		if ( dt === "number" || dt === "string" ) {
			if ( props ) {
				const p = props as MultiItemProps<Lookup, any>;
				if ( p.items && p.items.length > 0 ) {
					let find = p.items.find( x => data == ( p.toIdentifier ? p.toIdentifier( x ) : x.Id ) );
					if ( find ) return LocaleUtil.getLocalValue( find );
					return find;
				}
			}
		}
		return data;
	}

	toData( text: NullableFormValue<Lookup, any>, props: FormFieldProps<Lookup, any> ): NullableFormValue<Lookup, any> {
		if ( text && typeof text === "object" ) return text.Id;
		return text;
	}
}

export const lookupDisplayConverter = new LookupDisplayConverter();


class ServerDateConverter implements ValueConverter<string, Date> {
	fromData( data: NullableFormValue<string, Date>, props: FormFieldProps<string, Date> ): NullableFormValue<string, Date> {
		let dt = typeof data;
		if ( data && dt === "string" ) {
			return ( data as string ).asDate();
		}
	}

	toData( data: NullableFormValue<string, Date>, props: FormFieldProps<string, Date> ): NullableFormValue<string, Date> {
		let dt = typeof data;
		if ( data && dt === "object" ) {
			return ( data as Date ).asServerString();
		}
		return data;
	}
}

export const serverDateConverter = new ServerDateConverter();

class ServerDateDisplayConverter implements ValueConverter<string, Date> {
	fromData( data: NullableFormValue<string, Date>, props: FormFieldProps<string, Date> ): NullableFormValue<string, Date> {
		if ( data ) {
			return formatAppDate( data.asDate(), "en" );
		}
	}

	toData( data: NullableFormValue<string, Date>, props: FormFieldProps<string, Date> ): NullableFormValue<string, Date> {
		let dt = typeof data;
		if ( data && dt === "object" ) {
			return ( data as Date ).asServerString();
		}
		return data;
	}
}

export const serverDisplayDateConverter = new ServerDateDisplayConverter();